/**
 * Created by daniel on 01/05/17.
 */

import React, {Component} from 'react';
import ComponentSettings from "./ComponentSettings";
import {updateContentItem} from "../../../state/content/actions";
import {getContentDefinition} from "../../../state/config/selectors";
import {getContentItem} from "../../../state/content/selectors";
import {getUiSelectedItem} from "../../../state/ui/selectors";
import {connect} from "react-redux";

class ComponentSettingsContainer extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateComponent = this.handleUpdateComponent.bind(this);
  }
  handleUpdateComponent(updates) {
    if (!this.props.currentItemProps) return;
    this.props.updateItem(this.props.currentItemProps.contentId, updates, this.props.currentItemProps, this.props.currentItemDefaults);
  };
  
  render() {
    return (
      <ComponentSettings
        currentItem={this.props.currentItemProps ? {...this.props.currentItemDefaults, ...this.props.currentItemProps} : null}
        update={this.handleUpdateComponent}
        currentItemDefaults={this.props.currentItemDefaults}
      />
    );
  }
}

function mapStateToProps(state) {
  let currentItem = getUiSelectedItem(state);
  let currentItemProps = currentItem ? getContentItem(state, currentItem.contentId) : null;
  let currentItemDefaults = currentItemProps ? getContentDefinition(state, currentItemProps.configId) : null;
  return {
    currentItemProps,
    currentItemDefaults
  }
}
function mapDispatchToProps(dispatch) {
  return {
    updateItem: (contentId, newProps, oldProps, defaultProps) => dispatch(updateContentItem(contentId, newProps, oldProps, defaultProps))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComponentSettingsContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/ComponentSettingsContainer.js